import { render } from "./TranslateRating.vue?vue&type=template&id=4e145598"
import script from "./TranslateRating.vue?vue&type=script&lang=js"
export * from "./TranslateRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__